import React, { useContext, useEffect } from 'react';

import { Team } from './team';
import { Player } from './player';
import { Map } from '../../components/map/map';
import { PlayerContext } from '../../contexts/player';
import { OverlayContext } from '../../contexts/overlay';
import { GameDocumentContext } from '../../contexts/game-document';
import { GetGameLogo, GetGameName } from '../../utils/game-engine/base';

export const GameMapPage: React.FC = React.memo(() => {
  const [gameDocument] = useContext(GameDocumentContext);
  const [player] = useContext(PlayerContext);
  const [, setOverlay] = useContext(OverlayContext);

  const teamCode = player.playerState?.teamCode;

  useEffect(() => {
    setOverlay((prevState) => ({
      ...prevState,
      drawerIsOpen: false,
      gameName: GetGameName(gameDocument, player),
      gameLogo: GetGameLogo(gameDocument, player)
    }));
  }, []);

  return (
    <>
      <Map />
      <Player />
      {teamCode && <Team />}
    </>
  );
});
